// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"69321aea","982":"fa5c73bf"}[chunkId] + ".chunk.js";
};